const initialState = {
	isLoading: false,
	list: [],
	totalsize: 0,
};

function productSuggestReducer(state = initialState, action) {
    switch (action.type) {
		case 'LOADING_PRODUCT_SUGGEST':
			return {
				...state,
				isLoading: action?.payload
			};
		case 'ADMIN_LIST_PRODUCT_SUGGEST':
			return {
				...state,
				list: action?.payload?.products || [],
				totalsize: action?.payload?.totalsize || 0
			};
		default:
		  return state;
    }
}

export default productSuggestReducer;
